import React, { useState } from 'react';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';

const ConfirmButton = (props) => {

    const [isOpen, setIsOpen] = useState(false);

    let action = (() => setIsOpen(false));

    const executeAction = () => {
        setIsOpen(false);
        action();
    }

    let newProps = { ...props }

    if (newProps.onClick != null && typeof (newProps.onClick) === 'function') {
        action = newProps.onClick;
        newProps.onClick = (() => setIsOpen(true));
    }

    return (
        <>
            <Button {...newProps}>
                {props.children}
            </Button>
            <Modal centered isOpen={isOpen}>
                <ModalBody className='text-left'>
                    {props.body != null ? props.body : 'Are you sure you wish to proceed?'}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color={props.color != null ? props.color : 'Danger'}
                        onClick={executeAction}
                    >
                        {props.action != null ? props.action : 'Yes'}
                    </Button>
                    <Button onClick={() => setIsOpen(false)}>
                        {props.cancel != null ? props.cancel : 'Cancel'}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
};

export default ConfirmButton;